// @ts-nocheck
import { infoProps } from "@store/Themes/common/props/info";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
/* Store Custom Code - End */

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            ...infoProps.helpIcon,
            css: null as any,
        },
        cssOverrides: {
            tooltipWrapper: css`
                ${infoProps.helpIcon?.css}
                z-index: 1;
            `,
            tooltipClickable: css`
                ${focusStyles()}
                padding: 0;
            `,
            tooltipContainer: css`
                white-space: normal;
                filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2)); /* Store Custom Code */
            `,
            // Store Custom Code
            tooltipBody: css`
                background: ${getColor("common.accent")};
                color: ${getColor("text")};
            `,
            tooltipArrow: css`
                border-color: ${getColor("common.accent")} transparent transparent transparent;
            `,
        },
        typographyProps: {
            weight: "normal",
        },
    },
};

export default tooltip;
